function productSelectPosition() {
    const elementArrayPosition = getShowButtonColor().dataset.buttonColorPosition - 1;
    if (elementArrayPosition >= 0 && elementArrayPosition < getProductElement().length) {
        return elementArrayPosition;
    } else {
        return 1;
    }
}

function getProductElement() {
    return document.querySelectorAll("#combowise-product-element");
}

function getSelectElements() {
    return document.querySelectorAll(".combowise-mixmatch_select");
}

function addToCartButton() {
    return document.getElementsByClassName("combowise-mixmatch_ATC");
}

function getShowButtonColor() {
    return document.getElementById("showButtonColor")
}

function getComboButtons() {
    return document.getElementsByClassName("combowise_button");
}

function productSoldOut() {
    return getProductElement().length > 0 && getProductElement()[productSelectPosition()].dataset.available === "false";
}


function modelVariantTitle() {
    return document.getElementById("product_model_phrase").getAttribute("data-custom-model-phrase");
}

function finishVariantTitle() {
    return document.getElementById("product_finish_phrase").getAttribute("data-custom-finish-phrase");
}

function getComboWiseTitles() {
    return document.querySelectorAll(".combowise-mixmatch_title");
}

function customTitles() {
    if (getComboWiseTitles().length > 0) {
        getComboWiseTitles()[0].innerHTML = modelVariantTitle();
        getComboWiseTitles()[1].innerHTML = finishVariantTitle();
    }
}

function customTitleWithOptions(option) {
    const title = getComboWiseTitles()[productSelectPosition()];
    if (title) {
        let optionText = productSoldOut() ? "Esgotado" : option.textContent;
        title.innerHTML = `${finishVariantTitle()}&nbsp;&nbsp;<span class='variant-title'>${optionText}</span>`
    }
}


function customAddToCart() {
    const cartButtonElement = document.getElementsByClassName("combowise-mixmatch_ATC")[0];
    if(cartButtonElement){
        cartButtonElement.addEventListener("click", () => {
            cartButtonElement.classList.add("combowise-mixmatch_ATC_active");
            cartButtonElement.addEventListener("mouseover", () => {
                cartButtonElement.classList.add("combowise-mixmatch_ATC_active");
            });
        });
    }    
}

function applyButtonBackground(option, button) {
    const optionName = option.textContent.toLowerCase().includes("esgotado")
        ? option.textContent.split("-")[0].toLowerCase().trim()
        : option.textContent.toLowerCase().trim();

    button.style.background = optionName.includes("iphone")
        ? "gray"
        : `url(${getProductVariants()[`${optionName}`]})`;
}

function changeOptionsButton(select, buttons, button, option) {
    const soldOut = option.textContent.toLowerCase().includes("esgotado");
    applyButtonBackground(option, button);
    button.classList.add("combowise_button");
    button.classList.toggle("combowise-sold-out", soldOut);
    if (!soldOut) {
        button.classList.add("combowise_button_hover");
        button.addEventListener("click", () => {
            // Seleciona a option correspondente no select e altera o valor do select
            select.value = option.value;
            buttons.forEach(button => {
                button.classList.remove("combowise_button_active");
            });
            button.classList.add("combowise_button_active");
            customTitleWithOptions(option);
        });
    }
    buttons.push(button);
}

function addButtonsToNode(buttons, container) {
    // Adiciona os botões ao DOM
    container.classList.add("new_combowise-mixmatch_buttons");
    buttons.forEach(buttonNode => {
        container.appendChild(buttonNode);
    });
}


function getProductVariants() {
    const variantElements = getProductElement()[productSelectPosition()].querySelectorAll("#combowise-variant");
    // Iterando sobre os elementos variantes
    const variantsColor = {};
    variantElements?.forEach(variantElement => {
        // Obtendo os valores dos atributos data-variant-name e data-variant-background
        const variantName = variantElement.dataset.variantName.toLowerCase();
        const variantBackground = variantElement.dataset.variantBackground;

        // Exibindo os valores no console (você pode fazer o que desejar com esses valores)
        variantsColor[variantName] = variantBackground;
    });
    return variantsColor;
}

function optionButtonSoldOut() {
    if (productSoldOut()) {
        document.querySelectorAll(".combowise_button")[0]?.classList.add("combowise_button_active");
    }
}

function customAddToCartSoldOut() {
    const productElement = getProductElement();
    for (const product of productElement) {
        if (product.dataset.available === "false") {
            addToCartButton()[0].classList.add("add-to-cart-sold-out");
        }
    }
}

function tellWhenArrive() {
    const buyButtonSoldOutContainer = document.getElementById("buyButtonSoldOut");
    if (buyButtonSoldOutContainer.dataset.productAvailable.includes("false")) {
        const clonedButton = buyButtonSoldOutContainer.firstElementChild.cloneNode(true);
        addToCartButton()[0].parentNode.insertBefore(clonedButton, addToCartButton()[0].nextSibling);
    }

}


function getSelectOption() {
    const selects = getSelectElements();
    for (const option of selects[productSelectPosition()].options) {
        return option
    }
}

function selectSingleButton() {
    if (getComboButtons().length === 1) {
        getComboButtons()[0].classList.add("combowise_button_active");
    }

}

function removeEmptyOption() {
    const selects = getSelectElements();
    for (const select of selects) {
        let selectedIndex = -1;
        let hasNonEmptyOption = false;

        // Remove as opções vazias do DOM
        for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].textContent.trim() === "") {
                select.remove(i);
                i--; // Ajusta o índice após remover uma opção
            } else {
                // Se encontrarmos uma opção com texto não vazio, definimos o índice
                if (!hasNonEmptyOption) {
                    selectedIndex = i;
                    hasNonEmptyOption = true;
                }
            }
        }

        // Se não houver opção com texto não vazio, não fazemos nada
        if (!hasNonEmptyOption) {
            return;
        }

        // Seleciona a opção encontrada ou a próxima opção com texto não vazio
        select.options[selectedIndex].selected = true;
    }
}

function selectInitialOption(option, button) {
    if (option.selected) {
        button.classList.add("combowise_button_active");
    }
}


function customButtons() {
    getSelectElements()[productSelectPosition()].style.display = "none";
    const select = getSelectElements()[productSelectPosition()];
    const buttons = [];
    let count = 0;
    for (const option of select.options) {
        if (option.textContent) {
            // Cria um botão para cada option
            const button = document.createElement("button");
            if (!option.textContent.toLowerCase().includes("esgotado") && count === 0) {
                customTitleWithOptions(option);
                count++
            }
            if (count === 0) {
                customTitleWithOptions(option);
            }

            selectInitialOption(option, button);
            changeOptionsButton(select, buttons, button, option);
            customButtonType(button);
        }

    }

    const container = document.createElement("div");
    addButtonsToNode(buttons, container);
    // Insere o container no DOM, depois do select
    select.parentNode.insertBefore(container, select.nextSibling);
}

function customButtonType() {
    const buttonColorSquare = getShowButtonColor().dataset.buttonColorSquare === "true";
    const buttons = getComboButtons();

    for (const button of buttons) {
        if (buttonColorSquare) {
            button.classList.remove("combowise_button_round");
            button.classList.add("combowise_button_square");
        } else {
            button.classList.add("combowise_button_round");
            button.classList.remove("combowise_button_square");
        }
    }
}



function customCombowise() {
    customTitles();
    removeEmptyOption();
    if (getShowButtonColor().dataset.showColorButton === "true") {
        customButtons();
        customButtonType();
        selectSingleButton();
        optionButtonSoldOut();
    }
    customAddToCart();
    customAddToCartSoldOut();
    tellWhenArrive();

}

customCombowise();


